<template>
  <div>
    <van-form @submit="onSubmit" ref="myForm">
      <div class="information-box">
        <div class="information-title">{{ $t('form.title.arrive') }}</div>
        <div class="item" v-for="(item, index) in arriveInfo" :key="index">
          <van-field v-model="form[item.key]" :label="$t(item.label)" :right-icon="item.arrow"
            :placeholder="$t(item.placeholder)" :readonly="item.arrow === '' ? false : true"
            :clickable="item.arrow === '' ? false : true" @click="item.arrow === '' ? '' : openPop(item.key, index, 0)">
            <template #input v-if="item.type === 'sel'">
              <input type="text" readonly="readonly" :placeholder="$t3('请选择', 'Please select ...')"
                class="van-field__control" :value="dict[item.key][form[item.key]]" />
            </template>
            <template #label v-if="item.rule">{{ $t(item.label) }}<img class="asterisk" :src="star" alt="" /></template>
          </van-field>
        </div>
      </div>
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t('form.title.leave') }}</div>
        <div class="item" v-for="(item, index) in leaveInfo" :key="index">
          <van-field v-model="form[item.key]" :label="$t(item.label)" :right-icon="item.arrow"
            :placeholder="$t(item.placeholder)" :readonly="item.arrow === '' ? false : true"
            :clickable="item.arrow === '' ? false : true" @click="item.arrow === '' ? '' : openPop(item.key, index, 1)">
            <template #input v-if="item.type === 'sel'">
              <input type="text" readonly="readonly" :placeholder="$t3('请选择', 'Please select ...')"
                class="van-field__control" :value="dict[item.key][form[item.key]]" />
            </template>
            <template #label v-if="item.rule">{{ $t(item.label) }}<img class="asterisk" :src="star" alt="" /></template>
          </van-field>
        </div>
      </div>
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t3('归属地', 'Based in') }}</div>
        <div class="item">
          <van-field v-model="form.location" :label="$t3('归属地', 'Based in')" right-icon="arrow" readonly clickable
            @click="showaccommodation = true">
            <template #input>
              <input type="text" readonly="readonly" :placeholder="$t3('请选择', 'Please select ...')"
                class="van-field__control" :value="dict.location[form.location]" />
            </template>
            <template #label>{{ $t3('归属地', 'Based in') }}</template>
          </van-field>
        </div>
      </div>
    </van-form>

    <!-- 选择框 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" :default-index="form[nowKey]" @confirm="onConfirm"
        @cancel="showPicker = false">
        <template #option="item">
          {{ dict[nowKey][item] }}
        </template>
      </van-picker>
    </van-popup>
    <!-- 日期选择 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker v-model="currentDate" type="datetime" :title="$t3('选择年月日小时', 'Select date')"
        @confirm="onTimeConfirm" @cancel="showTimePicker = false" />
    </van-popup>
    <!-- 出行方式 -->
    <van-popup v-model="showaccommodation" position="bottom">
      <van-picker show-toolbar :columns="location" @confirm="onAccommodation" @cancel="showaccommodation = false">
        <template #option="item">
          {{ dict.location[item] }}
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>

import { objectMergLeft, fixedNumber } from '@/utils'
import { getDictSelArr } from '@/api/dict'
import { getStatusObjTwo } from '@/utils/common-config'
import { getArrivalInfo, getLeaveInfo, getAccommodationInfo } from '@/api/worker'
import { mapGetters } from 'vuex'

const tmpForm = {
  bearPartyA: undefined,
  travelWayA: undefined,
  flightA: undefined,
  seatNumA: undefined,
  departureTimeA: undefined,
  departurePlaceA: undefined,
  arrivalTimeA: undefined,
  arrivalPlaceA: undefined,
  bearPartyL: undefined,
  travelWayL: undefined,
  flightL: undefined,
  seatNumL: undefined,
  departureTimeL: undefined,
  departurePlaceL: undefined,
  arrivalTimeL: undefined,
  arrivalPlaceL: undefined,
  accommodationMode: undefined,
  location: undefined
}

export default {
  name: 'tripInfo',
  data() {
    return {
      star: require('@/assets/img/asterisk.svg'),
      form: {},
      arriveInfo: [{
        label: 'form.label.travel',
        key: 'travelWayA',
        arrow: 'arrow',
        type: 'sel',
        placeholder: 'form.label.choice'
      }, {
        label: 'form.label.number',
        key: 'flightA',
        arrow: '',
        placeholder: 'form.label.enter'
      }, {
        label: 'form.label.seat',
        key: 'seatNumA',
        arrow: '',
        placeholder: 'form.label.enter'
      }, {
        label: 'form.label.depTime',
        key: 'departureTimeA',
        arrow: 'arrow',
        placeholder: 'form.label.choice'
      }, {
        label: 'form.label.depAddress',
        key: 'departurePlaceA',
        arrow: '',
        placeholder: 'form.label.enter'
      }, {
        label: 'form.label.arrTime',
        key: 'arrivalTimeA',
        arrow: 'arrow',
        placeholder: 'form.label.choice'
      }, {
        label: 'form.label.destination',
        key: 'arrivalPlaceA',
        arrow: '',
        placeholder: 'form.label.enter'
      }],
      leaveInfo: [{
        label: 'form.label.lk_travel',
        key: 'travelWayL',
        arrow: 'arrow',
        type: 'sel',
        placeholder: 'form.label.choice'
      }, {
        label: 'form.label.number',
        key: 'flightL',
        arrow: '',
        placeholder: 'form.label.enter'
      }, {
        label: 'form.label.seat',
        key: 'seatNumL',
        arrow: '',
        placeholder: 'form.label.enter'
      }, {
        label: 'form.label.depTime',
        key: 'departureTimeL',
        arrow: 'arrow',
        placeholder: 'form.label.choice'
      }, {
        label: 'form.label.depAddress',
        key: 'departurePlaceL',
        arrow: '',
        placeholder: 'form.label.enter'
      }, {
        label: 'form.label.arrTime',
        key: 'arrivalTimeL',
        arrow: 'arrow',
        placeholder: 'form.label.choice'
      }, {
        label: 'form.label.destination',
        key: 'arrivalPlaceL',
        arrow: '',
        placeholder: 'form.label.enter'
      }],
      rules: {
        // accommodationMode: [{ msg: ['请选择住宿方式', 'Please select accmoomdation mode'] }]
      },
      accommodation: '本地住宿',
      showPicker: false,
      showTimePicker: false,
      columns: [],
      type: '',
      labelIdx: 0,
      showaccommodation: false,
      accomm: ['本地住宿'],
      currentDate: new Date(),
      dict: {
        needPickupA: [
          this.$t3('不需要', 'No'),
          this.$t3('需要', 'Yes')
        ],
        needPickupL: [
          this.$t3('不需要', 'No'),
          this.$t3('需要', 'Yes')
        ],
        travelWayA: {},
        travelWayL: {},
        accommodationMode: {},
        location: {
          广州本地: this.$t3('广州本地', 'Guangzhou'),
          外地: this.$t3('外地', 'Other Place'),
          Local: this.$t3('广州本地', 'Guangzhou'),
          Guangzhou: this.$t3('广州本地', 'Guangzhou'),
          'Other Place': this.$t3('外地', 'Other Place'),
        }
      },
      nowKey: '',
      needPickupA: [0, 1],
      needPickupL: [0, 1],
      location: [
        this.$t3('广州本地', 'Guangzhou'),
        this.$t3('外地', 'Other Place')
      ],
      travelWayA: [],
      travelWayL: [],
      accommodationMode: []
    }
  },
  computed: {
    ...mapGetters(['status'])
  },
  mounted() {
    this.getDictSelArr()
  },
  methods: {
    initForm(form) {
      this.form = Object.assign({}, tmpForm)
      objectMergLeft(this.form, form)
      if (form.haveGet) {
        objectMergLeft(this.form, form)
      } else {
        this.form.haveGet = true
        if (this.status) {
          this.getInfo()
        }
      }
    },
    validate() {
      return this.$validateI18n(this.form, this.rules)
    },
    getDictSelArr() {
      getDictSelArr({ conferenceId: this.$route.params.conferenceId, codes: 'arrival_travel_way,leave_travel_way,accommodation_mode' }).then(res => {
        if (Object.hasOwnProperty.call(res.data, 'arrival_travel_way')) {
          this.travelWayA = res.data.arrival_travel_way.map(x => x.code)
          this.dict.travelWayA = getStatusObjTwo(this.$t3, res.data.arrival_travel_way, 'code', 'name', 'nameEn')
        }
        if (Object.hasOwnProperty.call(res.data, 'leave_travel_way')) {
          this.travelWayL = res.data.leave_travel_way.map(x => x.code)
          this.dict.travelWayL = getStatusObjTwo(this.$t3, res.data.leave_travel_way, 'code', 'name', 'nameEn')
        }
        if (Object.hasOwnProperty.call(res.data, 'accommodation_mode')) {
          this.accommodationMode = res.data.accommodation_mode.map(x => x.code)
          this.dict.accommodationMode = getStatusObjTwo(this.$t3, res.data.accommodation_mode, 'code', 'name', 'nameEn')
        }
      })
    },
    getInfo() {
      getArrivalInfo().then(res => {
        const data = {}
        for (const x in res.data) {
          data[x + 'A'] = res.data[x]
        }
        objectMergLeft(this.form, data)
      })
      getLeaveInfo().then(res => {
        const data = {}
        for (const x in res.data) {
          data[x + 'L'] = res.data[x]
        }
        // data.needPickupL = data.needPickupL + ''
        objectMergLeft(this.form, data)
      })
      getAccommodationInfo().then(res => {
        objectMergLeft(this.form, res.data)
      })
    },
    onSubmit(values) {
      console.log('submit', values)
    },
    goNext() {
      this.$router.push('confirm')
    },
    goPrev() {
      this.$router.push('activityInte')
    },
    // 打开弹出框
    openPop(key, idx, type) {
      this.labelIdx = idx
      this.nowKey = key
      const key1 = key.replace(/[AL]$/, '')
      if (type === 0) { this.type = '抵达' } else { this.type = '离开' }
      if (key1 === 'arrivalTime' || key1 === 'departureTime') {
        this.currentDate = this.form[this.nowKey] ? new Date(this.form[this.nowKey].replace(/-/g, '/')) : new Date()
        this.showTimePicker = true
      } else {
        this.columns = this[key]
        this.showPicker = true
      }
    },
    // 关闭弹出框
    onConfirm(value) {
      this.form[this.nowKey] = value
      this.showPicker = false
    },
    onTimeConfirm(date) {
      this.form[this.nowKey] =
        date.getFullYear() + '-' + `${fixedNumber(date.getMonth() + 1)}-${fixedNumber(date.getDate())}` + ' ' + fixedNumber(date.getHours()) + ':' + fixedNumber(date.getMinutes())
      this.showTimePicker = false
    },
    onAccommodation(value) {
      this.form.location = {
        广州本地: '广州本地',
        外地: '外地',
        Local: '广州本地',
        Guangzhou: '广州本地',
        'Other Place': '外地'
      }[value]
      this.showaccommodation = false
    }
  }
}
</script>